import { cn } from "@/utils"
import { Button } from "antd"
import { MapPin as MapPinIcon } from "lucide-react"
import type { ComponentProps } from "react"

type MapPinProps = ComponentProps<typeof MapPinIcon>

export const MapPin = ({ className, ...props }: MapPinProps) => {
    return <Button type="text" size="small" >
        <MapPinIcon className={cn(" cursor-pointer size-5 text-primary", className)} {...props} />
    </Button>

}
